"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocketAPI = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

var SocketAPI = /*#__PURE__*/function () {
  function SocketAPI(_ref) {
    var lfToken = _ref.lfToken,
        customerKey = _ref.customerKey;
    (0, _classCallCheck2.default)(this, SocketAPI);
    this.lfToken = null;
    this.customerKey = null;
    this.requestAuth = null;
    this.helper = new _helper.Helper();
    this.lfToken = lfToken;
    this.customerKey = customerKey;
    this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
  }

  (0, _createClass2.default)(SocketAPI, [{
    key: "updateLMDGlobalSelectedOrders",
    value: function updateLMDGlobalSelectedOrders(payload) {
      return this.requestAuth.post('ROUTING_SOCKET', "v1/core/lastmile/order?".concat(process.env.VUE_APP_CUSTOMER_KEY, "=").concat(this.customerKey, "&dataType=").concat(payload.dataType), {}, payload);
    }
  }, {
    key: "updateLMDGlobalSelectedTrucks",
    value: function updateLMDGlobalSelectedTrucks(payload) {
      return this.requestAuth.post('ROUTING_SOCKET', "v1/core/lastmile/truck?".concat(process.env.VUE_APP_CUSTOMER_KEY, "=").concat(this.customerKey, "&dataType=add"), {}, payload);
    }
  }, {
    key: "updateLMDGlobalPlan",
    value: function updateLMDGlobalPlan(payload) {
      return this.requestAuth.post('ROUTING_SOCKET', "v1/core/lastmile/socketsave?".concat(process.env.VUE_APP_CUSTOMER_KEY, "=").concat(this.customerKey), {}, payload);
    }
  }]);
  return SocketAPI;
}();

exports.SocketAPI = SocketAPI;